import { useState } from "react"
import { Search, MapPin,  BookOpen, GraduationCap, Globe, } from "lucide-react"


// Données des universités kenyanes
const universities = [
    {
        id: 1,
        name: "Strathmore University ",
        location: "Nairobi",
        typeEducation: "Système britannique ",
        students: 23,
        type: "Private",
        image:
            "https://strathmore.edu/wp-content/uploads/2024/04/Web-slider-grad.jpg",
        programs: [
            "Non Répertorié sur MY KSP ! pour plus d'informations visitez leur site officiel en cliquant sur le lien en bleu ",
            // "Engineering",
            // "Law",
            // "Business Administration",
            // "Computer Science",
            // "Agriculture",
            // "Veterinary Medicine",
            // "Education",
        ],
        description: "Excellente réputation en business, finance, droit et cybersécurité. Très bon encadrement. Avantages : Bonne reconnaissance internationale, possibilité de poursuivre à l'étranger.",
        website: "https://strathmore.edu/fr/"
    },
    {
        id: 2,
        name: "USIU (United States International University) ",
        location: "Nairobi",
        typeEducation: "Système américain ",
        students: 23,
        type: "Private",
        image:
            "https://www.usiu.ac.ke/assets/image/gallery/1653685200_4161640311_1713942852.jpg",
        programs: [
            "Non Répertorié sur MY KSP ! pour plus d'informations visitez leur site officiel en cliquant sur le lien en bleu ",

        ],
        description: "Grande ouverture internationale, programmes en psychologie, informatique, communication. Avantages : Diplôme reconnu mondialement, campus multiculturel.",
        website: "https://www.usiu.ac.ke/school/shss/"
    },

    {
        id: 3,
        name: "Mount Kenya University  ",
        location: "Nairobi",
        typeEducation: "Système américain ",
        students: 23,
        type: "Private",
        image:
            "https://i0.wp.com/mku.ac.ke/wp-content/uploads/2025/06/Mount-Kenya-University-reap-big-from-Erasmus-exchange-program.png?fit=1250%2C450",
        programs: [
            "Non Répertorié sur MY KSP ! pour plus d'informations visitez leur site officiel en cliquant sur le lien en bleu ",

        ],
        description: "Très large choix de filières, accessibles aux étudiant•e•s internationaux.   Avantages : Présente dans plusieurs villes du Kenya, flexibilité dans l'inscription.",
        website: "https://mku.ac.ke/"
    },
    {
        id: 4,
        name: "Methodist University  ",
        location: "Nairobi",
        typeEducation: "Université confessionnelle ",
        students: 23,
        type: "Private",
        image:
            "https://www.methodist.edu/wp-content/uploads/2024/07/DSC_0450-740x740.jpg",
        programs: [
            "Non Répertorié sur MY KSP ! pour plus d'informations visitez leur site officiel en cliquant sur le lien en bleu ",

        ],
        description: "Très bon cadre pour des études en théologie, éducation ou gestion.   Avantages : Environnement calme et discipliné. ",
        website: "https://www.methodist.edu/"
    },
    {
        id: 5,
        name: "Catholic University of EasternAfrica (CUEA)",
        location: "Nairobi",
        typeEducation: "Université confessionnelle ",
        students: 23,
        type: "Private",
        image:
            "https://cuea.edu/wp-content/uploads/2025/05/PHOTO-2025-05-30-12-05-28.jpg",
        programs: [
            "Non Répertorié sur MY KSP ! pour plus d'informations visitez leur site officiel en cliquant sur le lien en bleu ",

        ],
        description: "Forte en sciences sociales, philosophie, éthique, droit canonique. Avantages : Encadrement spirituel et académique.",
        website: "https://cuea.edu/"
    },
    {
        id: 6,
        name: "	St. Paul's University",
        location: "Nairobi",
        typeEducation: "Université confessionnelle ",
        students: 23,
        type: "Private",
        image:
            "https://www.spu.ac.ke/images/slider/cache/76a967fc058e176388b9532422038364/May-Intake.jpg",
        programs: [
            "Non Répertorié sur MY KSP ! pour plus d'informations visitez leur site officiel en cliquant sur le lien en bleu ",

        ],
        description: "Chrétienne, Bonne réputation dans les domaines de la communication, relations internationales, sciences religieuses. Avantages : Ambiance familiale, axée sur la moralité et les valeurs.",
        website: "https://www.spu.ac.ke/"
    },
    {
        id: 7,
        name: "	Daystar University",
        location: "Nairobi",
        typeEducation: "Université chrétienne ",
        students: 23,
        type: "Private",
        image:
            "https://www.daystar.ac.ke/blog/uploads/1747833757_IMG_0564_1.jpg",
        programs: [
            "Non Répertorié sur MY KSP ! pour plus d'informations visitez leur site officiel en cliquant sur le lien en bleu ",

        ],
        description: "Université chrétienne anglophone, Très réputée en journalisme, communication, affaires internationales. Avantages : Forte communauté d'étudiant•e•s africains, activités sociales et culturelles.",
        website: "https://www.daystar.ac.ke/"
    }
]


// Composant Badge
const Badge = ({ children, variant = "default", className = "" }) => {
    const baseClasses = "inline-flex items-center px-2.5 py-0.5 rounded text-xs font-medium"
    const variants = {
        default: "bg-blue-100 text-blue-800",
        secondary: "bg-gray-100 text-gray-800",
        outline: "border dark:border-gray-600 border-gray-900 text-gray-700 bg-white",
    }

    return <span className={`${baseClasses} ${variants[variant]} ${className}`}>{children}</span>
}

// Composant Card
const Card = ({ children, className = "" }) => {
    return <div className={`bg-white  border border-gray-200 shadow-sm ${className}`}>{children}</div>
}

const CardHeader = ({ children }) => {
    return <div className="p-6 pb-4">{children}</div>
}

const CardContent = ({ children }) => {
    return <div className="px-6 pb-6">{children}</div>
}

const CardTitle = ({ children, className = "" }) => {
    return <h3 className={`text-lg font-semibold leading-none tracking-tight ${className}`}>{children}</h3>
}

const CardDescription = ({ children, className = "" }) => {
    return <p className={`text-sm text-gray-600 ${className}`}>{children}</p>
}

// Composant Input
const Input = ({ className = "", ...props }) => {
    return (
        <input
            className={`flex h-10 w-full rounded-md border border-gray-300 bg-white px-3 py-2 text-sm placeholder:text-gray-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent ${className}`}
            {...props}
        />
    )
}

// Composant Button
// const Button = ({ children, variant = "default", className = "", onClick, ...props }) => {
//     const baseClasses =
//         "inline-flex items-center justify-center  text-sm font-medium transition-colors  rounded  focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none"
//     const variants = {
//         default: "bg-green-600 text-white hover:bg-green-700 h-10 px-4 py-2",
//         outline: "border border-gray-300 bg-white hover:bg-gray-50 h-10 px-4 py-2",
//     }

//     return (
//         <button className={`${baseClasses} ${variants[variant]} ${className}`} onClick={onClick} {...props}>
//             {children}
//         </button>
//     )
// }

function UnivPrivate() {
    const [searchTerm, setSearchTerm] = useState("")
    const [selectedType, setSelectedType] = useState("All")

    const filteredUniversities = universities.filter((university) => {
        const matchesSearch =
            university.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
            university.location.toLowerCase().includes(searchTerm.toLowerCase()) ||
            university.programs.some((program) => program.toLowerCase().includes(searchTerm.toLowerCase()))
        const matchesType = selectedType === "All" || university.type === selectedType
        return matchesSearch && matchesType
    })

    return (
        <>
            <div className="min-h-screen  mtCGfreeUniv dark:bg-gray-900  from-green-50 to-red-50">
                {/* Header */}
                <header className="bg-white dark:bg-gray-900 shadow-sm ">
                    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
                        <GraduationCap className="h-8  w-8 text-door dark:text-door-dark" />
                        <div className="flex  items-center justify-between">
                            <div className="flex dark:bg-gray-900 items-center space-x-3">
                                <div>
                                    <h1 className="text-2xl font-bold dark:text-blue-500 text-gray-900">Universités</h1>
                                    <h2 className="text-gray-400  mt-1">
                                        {/* Découvrez les meilleures universités et leurs programmes d'études  */}
                                        <span className="text-gray-600 dark:text-gray-200">Activez votre accès Premium et laissez My Kenya Student Process vous guider à chaque étape de votre parcours universitaire au Kenya</span></h2>
                                </div>
                            </div>

                            {/* <svg xmlns="http://www.w3.org/2000/svg" className="w-8 h-8 dark:text-green-500 text-green-500 stroke-current" fill="none" viewBox="0 0 24 24" strokeWidth="1.5"><path strokeLinecap="round" strokeLinejoin="round" d="M12 6L20 9l-8 3-8-3 8-3z" /><path strokeLinecap="round" strokeLinejoin="round" d="M12 6v12" /><path strokeLinecap="round" strokeLinejoin="round" d="M20 12a8.1 8.1 0 01-8 8 8.1 8.1 0 01-8-8" /></svg> */}

                            {/* <div className="hidden md:flex items-center space-x-2">
              <div className="w-8 h-5 bg-black"></div>
              <div className="w-8 h-5 bg-red-600"></div>
              <div className="w-8 h-5 bg-green-600"></div>
            </div> */}
                        </div>
                    </div>
                </header>

                {/* Statistiques */}
                <section className="bg-white dark:bg-gray-900 ">
                    <div className="max-w-7xl mx-auto px-4  sm:px-6 lg:px-8 py-8">
                        <div className="grid  grid-cols-1 p-6 border border-gray-3  00 dark:border dark:border-gray-700 rounded-lg dark:bg-gray-800 md:grid-cols-1 gap-6">
                            <div className="text-center">
                                <div className="bg-blue-100 rounded-full w-12 h-12 flex items-center justify-center mx-auto mb-2">
                                    <span className=" text-3xl text-blue-600 font-bold">
                                        {universities.filter((uni) => uni.type === "Private").length}
                                    </span>
                                </div>
                                <div className="dark:text-gray-300 text-gray-600">Universités privées répertoriées sur MY KSP</div>
                            </div>
                        </div>
                    </div>
                </section>

                {/* Filtres  */}
                <section className="max-w-7xl  -mt-10 mx-auto px-4 sm:px-6 lg:px-8 py-8">
                    <div className="bg-white dark:bg-gray-900 rounded-lg shadow-sm p-6 mb-8">
                        <div className="flex  flex-col md:flex-row gap-4">
                            <div className="flex-1  relative">
                                <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 h-5 w-5" />
                                <Input
                                    type="text"
                                    placeholder="Rechercher par université, ville ou programme..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                    className="pl-10 border-gray-300 dark:bg-gray-800 "
                                />
                            </div>
                            
                        </div>
                    </div>

                    {/* Liste des Universités */}
                    <div className="grid grid-cols-1  lg:grid-cols-2 gap-6">
                        {filteredUniversities.map((university) => (
                            <Card key={university.id} className="hover:shadow-lg rounded-lg border border-gray-100 shadow dark:border-gray-600 xl:p-2 dark:bg-gray-800 transition-shadow duration-300 overflow-hidden">
                                {/* Image de l'université */}
                                <div className="relative h-48 w-full overflow-hidden bg-gray-200">
                                    <img
                                        src={university.image || "/placeholder.svg"}
                                        alt={`Campus de ${university.name}`}
                                        className="w-full h-full rounded border object-cover transition-transform duration-300 hover:scale-105"
                                        onError={(e) => {
                                            e.target.src =
                                                "https://images.unsplash.com/photo-1562774053-701939374585?ixlib=rb-4.0.3&auto=format&fit=crop&w=1000&q=80"
                                        }}
                                    />
                                    <div className="absolute  top-4 right-4">
                                        <Badge variant={university.type === "Public" ? "default" : "secondary"}>
                                            {university.type === "Public" ? "Publique" : "Privée"}
                                        </Badge>
                                    </div>
                                </div>

                                <CardHeader>
                                    <div className="flex justify-between items-start">
                                        <div>
                                            <CardTitle className="text-xl dark:text-door-dark text-gray-900">{university.name}</CardTitle>

                                        </div>
                                    </div>
                                </CardHeader>
                                <CardContent>
                                    <p className="text-gray-600 dark:text-gray-200 mb-4">{university.description}</p>

                                    <div className="grid grid-cols-2 gap-4 mb-4">
                                        {/* <div className="flex items-center text-sm dark:text-gray-200 text-gray-600">
                      <Users className="h-4 w-4 dark:text-green-300 mr-2" />
                      {university.students.toLocaleString()} étudiants
                    </div> */}

                                    </div>

                                    <div>
                                        <h4 className="font-semibold dark:text-gray-100 text-gray-900 mb-2">Programmes d'études :</h4>
                                        <div className="flex flex-wrap gap-2">
                                            {university.programs.map((program, index) => (
                                                <Badge key={index} variant="outline" className="text-xs dark:bg-gray-700 dark:text-white  ">
                                                    {program}
                                                </Badge>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="flex mt-5 dark:text-gray-200  items-center text-sm text-gray-600">
                                        <BookOpen className="h-4 dark:text-door-dark w-4 mr-2" />
                                        Type d'éducation : {university.typeEducation}
                                    </div>

                                    <CardDescription className="flex gap-2 items-center mt-2">
                                        <MapPin className="h-4 w-4 dark:text-gray-200 mr-1" />
                                        <span className="dark:text-gray-200">

                                            {university.location}
                                        </span>

                                        <a
                                            href={university.website}
                                            className="text-blue-600 dark:text-blue-400  hover:underline flex items-center"
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <Globe className="h-4 w-4 mr-1" />
                                            {university.website}
                                        </a>

                                    </CardDescription>

                                </CardContent>
                            </Card>
                        ))}
                    </div>

                    {filteredUniversities.length === 0 && (
                        <div className="text-center py-12">
                            <GraduationCap className="h-12 w-12 text-gray-400 mx-auto mb-4" />
                            <h3 className="text-lg font-medium text-gray-900 mb-2">Aucune université trouvée</h3>
                            <p className="text-gray-600">Aucune université</p>
                        </div>
                    )}

                 
                </section>
            </div>
        </>
    )
}

export default UnivPrivate
